module.exports = __webpack_public_path__ + "img/receipt3.7022766d.png";